import type { DocMigration } from "../docMigration";

// Underlays used to be placed in plan views only, so `underlayViewType` did not exist. Now that an
// underlay can also be placed in an elevation view the field is required, and every underlay that
// predates it is a plan view underlay.
interface UnderlayJson {
  underlayViewType?: string;
}

interface MigrationDocJson {
  underlays?: Record<string, UnderlayJson>;
  roofUnderlays?: Record<string, UnderlayJson>;
}

const migration: DocMigration = {
  id: "20260831_underlay_view_type",
  description: 'Backfill underlayViewType: "PLAN_VIEW" onto underlays that predate the field',
  apply(json) {
    const doc = json as MigrationDocJson;

    for (const underlay of [...Object.values(doc.underlays ?? {}), ...Object.values(doc.roofUnderlays ?? {})]) {
      underlay.underlayViewType ??= "PLAN_VIEW";
    }

    return json;
  },
};

export default migration;
